/**
 * Sleep util
 * @param {Number} ms milliseconds program should sleep for
 * ```js
 * import sleep from '@utils/sleep.js'
 * await sleep(500) // sleep for 500ms
 * ```
 */
export default (ms) => new Promise((resolve) => setTimeout(resolve, ms))
